import unixTimeConverter from './unixTimeConverter';

const normalizeWeatherApi = (data) => {
    var date = new Date();
    var currentHour = date.getHours();

    const newObject = {};

    newObject.location = data.location;

    newObject.current = {};
    newObject.current.temp = Math.trunc(data.current.temp_c);
    newObject.current.lastUpdate = data.current.last_updated.slice(11,16);

    newObject.daily = [];
    data.forecast.forecastday.map((day) => 
        newObject.daily.push(
            {date: unixTimeConverter(day.date_epoch, 'day'),
             date_unix: day.date_epoch,
             tempMin: Math.trunc(day.day.mintemp_c),
             tempMax: Math.trunc(day.day.maxtemp_c),
             iconSrc: day.day.condition.icon,
             wind: Math.trunc(day.day.maxwind_kph),
             rainProb: day.day.daily_chance_of_rain,
             rain: day.day.totalprecip_mm
            }
        )
    )
            
    newObject.hourly = [];
    data.forecast.forecastday.map((day, dayIndex) => 
        day.hour.map((hour, hourIndex) => 
            // Esta api envía las horas desde las 00:00, no desde la hora actual, 
            // así que calculo primero la hora actual para que mapee el array a   
            // partir del index que coincida con la hora actual.
            (dayIndex === 0 && hourIndex < currentHour) 
                ? null 
                : newObject.hourly.push(
                    {hour: unixTimeConverter(hour.time_epoch, 'hour'),
                     hour_unix: hour.time_epoch,
                     temp: Math.trunc(hour.temp_c),
                     iconSrc: hour.condition.icon,
                     wind: Math.trunc(hour.wind_kph),
                     rainProb: hour.chance_of_rain,
                     rain: hour.precip_mm
                    }
                  )               
        )
    )

    return newObject;
}

export default normalizeWeatherApi;